<template>
  <div>
    <PreLoaderSection v-if="state.isPreLoaderShowing" :options="{ 'height': '500' }" />
    <div class="summary-top-videos" v-show="!state.isPreLoaderShowing">
      <Section>
        <div class="section-header" slot="header">
          <div class="title">
            <div>Top 20 Videos</div>
            <div class="summary-type">
              <select class="custom-select" v-model="sortBy">
                <option value="plays">Plays</option>
                <option value="watch-duration">Watch Duration</option>
                <option value="10seconds-play">10s Plays</option>
              </select>
            </div>
            <div class="spinner-border spinner-border-sm ml-3" role="status" v-if="state.isLoading" />
          </div>
        </div>
        <div
          class="section-body summary-top-videos"
          :class="{
            '--disabled': state.isLoading
          }">
          <div class="top-videos-table">
            <TopVideosList :videos="videos.data" v-if="!videosEmpty" />
            <EmptyMessage v-if="videosEmpty">
              ไม่พบข้อมูลในช่วงเวลาที่เลือก
            </EmptyMessage>
          </div>
        </div>
      </Section>
    </div>
  </div>
</template>

<script>

import _ from 'lodash';
import { getTopVideosSortedByFilter } from '@/summary/api';
import generateLink from '@/utils/generateLink';

import Section from '@/components/Section.vue';
import PreLoaderSection from '@/components/PreLoaderSection.vue';
import TopVideosList from '@/summary/TopVideosList.vue';
import EmptyMessage from '@/components/EmptyMessage.vue';

export default {
  mixins: [generateLink],
  components: {
    Section,
    PreLoaderSection,
    TopVideosList,
    EmptyMessage,
  },
  data() {
    return {
      state: {
        isPreLoaderShowing: true,
        isLoading: false,
      },
      videos: {},
      sortBy: 'plays',
    };
  },
  watch: {
    '$route.query': {
      async handler(query) {
        const filter = this.generateQuery(query);
        await this.loadTopVideosSortedByFilter(filter);
      },
    },
    sortBy() {
      const filter = this.generateQuery(this.$route.query);
      this.$router.push({ query: Object.assign({}, this.$route.query, { sortBy: this.sortBy }) });
      this.loadTopVideosSortedByFilter(filter);
    },
  },
  computed: {
    videosEmpty() {
      return _.isEmpty(this.videos.data);
    },
  },
  async created() {
    const filter = await this.generateQuery(this.$route.query);
    this.sortBy = this.$route.query.sortBy || 'plays';
    this.loadTopVideosSortedByFilter(filter);
  },
  methods: {
    async loadTopVideosSortedByFilter(filter) {
      this.state.isLoading = true;
      const filterWithSortBy = {
        sortBy: this.sortBy,
        ...filter,
      };
      const response = await getTopVideosSortedByFilter(filterWithSortBy);
      this.videos = response.data;
      this.state.isPreLoaderShowing = false;
      this.state.isLoading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.summary-top-videos {
  .title {
    display: flex;
    align-items: center;

    .summary-type {
      margin-left: $spacer * 1.25;
    }

    .spinner-border {
      color: $gray-500;
    }
  }

  &.--disabled {
    opacity: .25;
    pointer-events: none;
  }
}

@media (max-width: 991.98px) {
  .summary-top-videos {

    .section-header {
      width: 100%;

      .title {
        width: 100%;

        .summary-type {
          margin-left: auto;
        }
      }
    }
  }
}

</style>
